import { configureStore } from '@reduxjs/toolkit';
import invoiceReducer from '../features/invoiceSlice'
import offerReducer from '../features/offerSlice'
import bookInvoiceReducer from '../features/bookInvoiceSlice'

import { storageService } from '../utils/storageService';
import { Invoice } from '../types/invoiceForm';
import { Offer } from '../types/offerForm';
import { BookData } from '../types/bookInvoice';

const STORAGE_KEY = ['invoices', 'offers', 'book_invoices'];

// Load from localStorage
const persistedInvoices = storageService.getItem<Invoice[]>(STORAGE_KEY[0]) || [];
const persistedOffers = storageService.getItem<Offer[]>(STORAGE_KEY[1]) || [];
const persistedBookInvoices = storageService.getItem<BookData[]>(STORAGE_KEY[2]) || [];

const store = configureStore({
  reducer: {
    invoices: invoiceReducer,
    offers: offerReducer,
    bookInvoices: bookInvoiceReducer
  },
  preloadedState: {
    invoices: persistedInvoices,
    offers: persistedOffers,
    bookInvoices: persistedBookInvoices,
  },
});

store.subscribe(()=>{
  const state = store.getState();
  storageService.setItem( STORAGE_KEY[0], state.invoices)
  storageService.setItem( STORAGE_KEY[1], state.offers)
  storageService.setItem( STORAGE_KEY[2], state.bookInvoices)
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
